module.exports = __webpack_public_path__ + "img/grass.13493bd0.png";